export default __webpack_public_path__ + "static/media/1_0012.16fa2aa9.webp";